import * as React from 'react';
import { GridComponent, ColumnsDirective, ColumnDirective, Page, Toolbar, Edit, Inject } from '@syncfusion/ej2-react-grids';
//import { data } from './data';
//import {config} from '../../_helpers'
import { SampleBase } from '../../syncfusion/sample-base';
import { DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { authenticationService } from '../../_services'
import { setCulture,loadCldr,L10n  } from '@syncfusion/ej2-base';
import * as gregorian from 'cldr-data/main/es-CO/ca-gregorian.json';
import * as numbers from 'cldr-data/main/es-CO/numbers.json';
import * as timeZoneNames from 'cldr-data/main/es-CO/timeZoneNames.json';
import * as numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
import * as weekData from 'cldr-data/supplemental/weekData.json';// To load the culture based first day of week
import * as L10n_es from '@syncfusion/ej2-locale/src/es.json'
setCulture("es-CO");
L10n.load({"es-CO":L10n_es.es});


/* let data = new DataManager({ url: config.HostUrlAuth+"usuario/", 
                                      adaptor: new WebApiAdaptor(),
                                      headers:[{ "Content-Type":  "application / json",
                                                  "api-token": `${authenticationService.currentUserValue.jwt_token}`}]}); 

 */

export class CustomWebApiAdaptor extends WebApiAdaptor {  
    processResponse() {
        //calling base class processResponse function
        const original = super.processResponse.apply(this, arguments);
        //Adding serial number
        // console.log(original);
        return { result: original  , count: original.count };
    }
    /* beforeSend (dm, request) { 
        request.open ( 'GET' , 'UrlDatasource' );  // personalizando la URL de lHttpRequest                                   
       request.setRequestHeader ( 'Content-Type' , 'application / json' ); 
        dm.dataSource.headers = [{ "api-token": `${token}` }]; // configuración de encabezado   
    }  */
} 
/* let data;

async function ConsultaUsuario () {
  data = await new DataManager({ url: config.HostUrlAuth+"usuario/", 
                            adaptor: new WebApiAdaptor(),
                            headers:[{ "Content-Type":  "application / json",
                                        "api-token": `${authenticationService.currentUserValue.jwt_token}`}]}); 
  //console.log(response);  
  return  data
} */

export class userProfileAll extends SampleBase {
    constructor() {
        super(...arguments);
        
        this.config = window.config;
        this.toolbarOptions = ['Add', 'Edit', 'Delete', 'Update', 'Cancel'];
        this.editSettings = { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Normal' };
        this.editparams = { params: { popupHeight: '300px' } };
        this.validationRules = { required: true };
        this.validationERules = { required: true, email: true };
        this.orderidRules = { required: true, number: true };
        this.pageSettings = { pageCount: 5 };
        this.format = { type: 'dateTime', format: 'M/d/y hh:mm a' };
        //this.hostUrl = 'https://ej2services.syncfusion.com/production/web-services/';
        //this.data = new DataManager({ url: this.hostUrl + 'api/Orders', 
        this.data = new DataManager({ url: JSON.parse(sessionStorage.config).HostUrlAuth+"usuario/", 
                                      adaptor: new CustomWebApiAdaptor(),
                                      headers:[{ "Content-Type":  "application / json",
                                                  "api-token": `${authenticationService.currentUserValue.jwt_token}`
                                                }],
                                      crossDomain: true});  
                                      
        debugger;
        this.dataGroup = new DataManager({ url: JSON.parse(sessionStorage.config).HostUrlAuth+"grupo/", 
                                          adaptor: new CustomWebApiAdaptor(),
                                          headers:[{ "Content-Type":  "application / json",
                                                      "api-token": `${authenticationService.currentUserValue.jwt_token}`
                                                    }],
                                          crossDomain: true}); 
        

        console.log('thisdata');
        console.log(this.data);
        console.log(this.dataGroup);

       
    }
    onClickTabla () {
      console.log('click tabla');
      console.log(this.gridObj);
    }
    render() { 
      loadCldr(numberingSystems, {"es-CO":gregorian.main["es-CO"]}, {"es-CO":numbers.main["es-CO"]}, {"es-CO":timeZoneNames.main["es-CO"]}, weekData);
        return (<div className='control-pane'>
        <div className='control-section'>
          <GridComponent dataSource={this.data} locale='es-CO' toolbar={this.toolbarOptions} allowPaging={true} editSettings={this.editSettings} pageSettings={this.pageSettings} ref={(scope) => { this.gridObj = scope; }} onClick = {this.onClickTabla = this.onClickTabla.bind(this)}>
            <ColumnsDirective>
              <ColumnDirective field='email' headerText='email' width='120' validationRules={this.validationERules} isPrimaryKey={true}></ColumnDirective>
              <ColumnDirective field='nombre' headerText='nombre' width='150' ></ColumnDirective>
              <ColumnDirective field='codgrupo' headerText='codgrupo' width='120'  textAlign='Right' validationRules={this.orderidRules} ></ColumnDirective>
              {/* <ColumnDirective field='codgrupo' headerText='codgrupo' foreignKeyValue='nomgrupo' foreignKeyField='NomGrupo' dataSource={this.dataGroup} width='120'  textAlign='Right' validationRules={this.orderidRules} ></ColumnDirective> */}
              <ColumnDirective field='idioma' headerText='idioma' width='120' ></ColumnDirective>
              <ColumnDirective field='creado' headerText='creado' editType='datetimepickeredit' edit = {{params:{locale: "en", buttonText: 'Hoy'}}} allowEditing={true} format='yMd' width='170' ></ColumnDirective> 
              <ColumnDirective field='modificado' headerText='modificado' editType='datetimepickeredit' allowEditing={false} format='yMd' width='170' ></ColumnDirective>
              
              {/* <ColumnDirective field='OrderID' headerText='Order ID' width='120' textAlign='Right'></ColumnDirective>
                            <ColumnDirective field='CustomerID' headerText='Customer ID' width='160'></ColumnDirective>
                            <ColumnDirective field='EmployeeID' headerText='Employee ID' width='120' textAlign='Right'/>
                            <ColumnDirective field='Freight' headerText='Freight' width='150' format='C2' textAlign='Right'/>
                            <ColumnDirective field='ShipCountry' headerText='Ship Country' width='150'></ColumnDirective> */}
          </ColumnsDirective>
            <Inject services={[Page, Toolbar, Edit]}/>
          </GridComponent>
        </div>
      </div>);
    }
}